module.exports = __webpack_public_path__ + "img/banner3_2.87810dd0.png";